import axios from "axios";
import queryString from "query-string";
import * as helper from "../helpers";
axios.defaults.headers.common['X-CSRF-Token'] =
  document.querySelector('meta[name="csrf-token"]').content;
  
export const getSmsData = async () => {
  try {
    let response = await axios.get('/sms_center/api/sms_data');
    return response;
  } catch(error) {
    return { message: "There was an error processing this request." };
  }
};

export const getTextMessageThread = async (id) => {
  try {
    let response = await axios.get('/sms_center/api/text_message_threads/' + id);
    return response;
  } catch(error) {
    return { message: "There was an error processing this request." };
  }
};


export const getTextMacros = async (patient_id, cpr_id) => {
  var url = 'physicians/api/text_macros?';
  if (patient_id) {
    url += `patient_id=${ patient_id }`;
  }

  if (cpr_id) {
    url += `&cpr_id=${ cpr_id }`;
  }

  const request = queryString.stringifyUrl({
    url: url
  });

  const res = await fetch(request);
  if (!res.ok) {
    const json = await res.json();
    throw json;
  }
  const data = await res.json();
  return data;
};

export const postTextMessageThread = async (req) => {
  try {
    let response = await axios.post('/sms_center/api/text_message_threads', {
      'text_message_thread': req
    });
    return response;
  } catch(error) {
    return { message: "There was an error processing this request." };
  }
};

export const putTextMessageThread = async (req) => {
  try {
    let response = await axios.put('/sms_center/api/text_message_threads', {
      'text_message_thread': req
    });
    return response;
  } catch(error) {
    return { message: "There was an error processing this request." };
  }
};
